import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-propositions',
  templateUrl: './propositions.component.html',
  styleUrls: ['./propositions.component.css']
})
export class PropositionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
